




















import Component, { mixins } from 'vue-class-component';
import BasePageMixin from '@/mixins/base-page-mixin';
import SubjectServices, { SubjectDto } from '@/services/subject';
import CategoryServices, { CategoryDto } from '@/services/category';
import { CategoryItem } from '@/interfaces/category-item';
import { Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ApproveModal from '../../components/approve-modal.vue';
import { confirmDelete } from '@/libs/decorator';

@Component({
  components: { ApproveModal }
})
export default class Subject extends mixins(BasePageMixin) {
  bread = [{ name: '参照库' }, { name: '主题表' }];
  subSrv = new SubjectServices();
  categorySrv = new CategoryServices();

  menu: CategoryItem[] = [
    {
      title: '主题表',
      icon: 'fa-cube',
      oprate: [
        { name: '新建目录', icon: 'fa-folder', key: 'addFolder' },
        { name: '刷新', icon: 'fa-refresh', key: 'refresh' }
      ],
      expand: true,
      children: []
    }
  ];

  async created() {
    this.getCategory();
  }

  // 获取目录
  async getCategory() {
    this.menu[0].loading = true;
    let list = await this.categorySrv.getList({ categoryType_eq: 4 });
    this.menu[0].children = list.map((cate: CategoryDto) => ({
      title: cate.categoryName,
      icon: cate.icon,
      type: 'folder',
      record: cate,
      oprate: [
        { name: '新建主题表', icon: 'fa-plus-circle', permissionKey: 'SUB_ADD', key: 'add' },
        { name: '编辑目录', icon: 'fa-edit', key: 'editFolder' },
        { name: '删除目录', icon: 'fa-trash', key: 'removeFolder' }
      ],
      expand: false,
      id: cate.id,
      children: []
    }));
    this.menu[0].loading = false;
  }

  // 获取目录下文件
  async openFolderById(id: number) {
    let index = this.menu[0].children.findIndex((v: any) => v.id == id);
    this.menu[0].children[+index].loading = true;
    let list = await this.subSrv.getList({ subCategoryId_eq: id });
    let plist: object[] = [];
    list.forEach((sub: SubjectDto) => {
      plist.push({
        title: sub.subName,
        key: this.getDetailUri(sub),
        icon: 'fa-table',
        id: sub.id,
        record: sub,
        oprate: [
          { name: '编辑', icon: 'fa-edit', permissionKey: 'SUB_UPD', key: 'edit' },
          { name: '提交审批', icon: 'fa-share', permissionKey: 'SUB_REQ', key: 'approve' },
          { name: '删除', icon: 'fa-trash', permissionKey: 'SUB_DEL', key: 'remove' }
        ]
      });
    });
    this.menu[0].children[+index].children = plist;
    this.menu[0].children[+index].expand = true;
    this.menu[0].children[+index].loading = false;
  }

  getDetailUri = (dim: SubjectDto) => `/decision/subject/detail?id=${dim.id}`;

  approveVisible: boolean = false;
  approveInfo: any = {};
  command(key: string, record: any) {
    switch (key) {
      case 'add': // 新建
        this.replaceUrl('/decision/subject/add?categoryId=' + record.id);
        break;
      case 'edit': // 编辑
        if (record.approveStatus == 2 || record.approveStatus == 3) {
          this.$message.error('当前状态不能编辑');
          return false;
        }
        this.replaceUrl('/decision/subject/edit?id=' + record.id);
        break;
      case 'remove': // 删除
        if ([1, 2, 3, 7].includes(record.approveStatus)) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        if ([4, 5].includes(record.approveStatus) && record.status == 0) {
          this.$message.error('当前状态不能删除');
          return false;
        }
        this.removeSubject(record.id);
        break;
      case 'approve': // 审批
        if (record.approveStatus > 1) {
          this.$message.error('当前状态不能提交审批');
          return false;
        }
        this.approveInfo = { type: 2, code: record.subCode, approveStatus: record.approveStatus, uri: this.getDetailUri(record) };
        this.approveVisible = true;
        break;
      case 'addFolder': // 新建目录
        this.folderId = 0;
        this.visible = true;
        break;
      case 'editFolder': // 编辑目录
        this.folderId = record.id;
        this.visible = true;
        break;
      case 'removeFolder': // 删除目录
        this.removeFolder(record.id);
        break;
      case 'expandFolder': // 展开目录
        this.openFolderById(record.id);
        break;
      case 'link':
        this.replaceUrl(record);
        break;
      case 'refresh':
        this.reloadMenu();
      default:
        break;
    }
  }

  async removeFolder(id: number) {
    let res = await this.categorySrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
  }

  @confirmDelete()
  async removeSubject(id: number) {
    let res = await this.subSrv.remove(id);
    if (!res) return false;
    this.$message.success('操作成功');
    this.reloadMenu();
    this.onDeleteRemoveTab('subject', id);
  }

  @State RELOAD_SUB_MENU: any;
  @Watch('RELOAD_SUB_MENU')
  reloadMenu() {
    // 重新载入目录下文件
    let openFolderIds: number[] = [];
    this.menu[0].children.forEach((v: any, index: number) => {
      if (v.expand) {
        openFolderIds.push(v.id);
      }
    });
    this.getCategory();
    openFolderIds.forEach(id => this.openFolderById(id));
  }
}
